import { render, staticRenderFns } from "./MultipleRegressionCard.vue?vue&type=template&id=142c029a"
import script from "./MultipleRegressionCard.vue?vue&type=script&lang=js"
export * from "./MultipleRegressionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports